import { useState } from "react";
import { Flask } from "@phosphor-icons/react";
import { api, act } from "@/lib/api";
import { Badge } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const Rate = ({ v, r, win }) => (
  <span className={`font-mono text-[11px] ${win ? "text-[#00C781]" : "text-zinc-400"}`}>{v}: {r.sent} sent · {r.replied} replied ({Math.round(r.reply_rate * 100)}%){win ? " · winner" : ""}</span>
);

export const AbStep = ({ i, s, stats, onChange, campaignId, onGenerated }) => {
  const [busy, setBusy] = useState(false);
  const gen = async () => {
    setBusy(true);
    await act(() => api.post(`/campaigns/${campaignId}/ab-variant`, { step: i }), "Variant B written — split 50/50 from the next send");
    setBusy(false);
    onGenerated();
  };
  if (!s.subject_b) return (
    <Button size="sm" variant="ghost" className="mt-2 gap-1 text-xs" disabled={busy} data-testid={`ab-generate-${i}`} onClick={gen}><Flask /> {busy ? "Writing variant…" : "A/B test this step"}</Button>
  );
  return (
    <div className="mt-3 border border-dashed border-[#007AFF]/40 rounded-md p-3 space-y-2" data-testid={`ab-variant-${i}`}>
      <div className="flex items-center gap-2 flex-wrap"><Badge v="variant B" tone="blue" />{s.hypothesis && <span className="text-[11px] text-zinc-400">{s.hypothesis}</span>}</div>
      <Input data-testid={`ab-subject-b-${i}`} value={s.subject_b} onChange={(e) => onChange(i, "subject_b", e.target.value)} className="bg-black" />
      <Textarea rows={5} data-testid={`ab-body-b-${i}`} value={s.body_b || ""} onChange={(e) => onChange(i, "body_b", e.target.value)} className="bg-black text-sm" />
      {stats && <div className="flex flex-col gap-0.5" data-testid={`ab-stats-${i}`}><Rate v="A" r={stats.A} win={stats.winner === "A"} /><Rate v="B" r={stats.B} win={stats.winner === "B"} /></div>}
      <div className="text-[11px] text-zinc-500">The manager declares a winner once both variants reach the charter sample size and differ by 5+ points.</div>
    </div>
  );
};
